import { render, staticRenderFns } from "./getbox.vue?vue&type=template&id=2f4613f5&scoped=true"
import script from "./getbox.vue?vue&type=script&lang=js"
export * from "./getbox.vue?vue&type=script&lang=js"
import style0 from "./getbox.vue?vue&type=style&index=0&id=2f4613f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4613f5",
  null
  
)

export default component.exports